import { CurrencyPair } from 'types/currency-pair'

export const DEFAULT_CURRENCY_PAIR: CurrencyPair = [
  { Symbol: 'BTC', Description: 'Bitcoin' },
  { Symbol: 'USD', Description: 'USD Coin' },
]
